import React, {useContext} from 'react';
import {NotificationContext} from "./Notification";

export const useNotification = () => {
    const context = useContext(NotificationContext)
    return context
};